import { Component, Input, OnInit } from '@angular/core';
import { UtilitiesService } from 'app/@core/services/utilities.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'vertical-progress-bar',
  templateUrl: './vertical-progress-bar.component.html',
  styleUrls: ['./vertical-progress-bar.component.scss']
})
export class VerticalProgressBarComponent {
  @Input() progressBarData: any;
  @Input() shipmentEvents: any;
  @Input() shipment: any;
  latestEnrouteEvent: any;
  selectedTimeZone: string;
constructor(private toastr: ToastrService,private utilityService:UtilitiesService){}
  ngOnInit(): void {
       // Subscribe first to always respond to changes in timezone
    this.utilityService.timeZone$.subscribe((zone: string) => {
      this.selectedTimeZone = zone;
    });
  }
  /**
 * Show Enroute On Condition 
 */
  shouldShowEnRoute(index: number, stopNumber: number): boolean {
    // return index === this.events.currentStopIndex && index < this.shipment.stops.length - 1 && index > 0 && this.checkEnrouteEvent(stopNumber);
    this.latestEnrouteEvent = this.shipmentEvents.events[0]; // Assuming this is the most recent event
    const isEnroute =
      this.latestEnrouteEvent?.taStatusDescription?.toLowerCase().includes('en route') &&
      this.latestEnrouteEvent?.stopNumber === stopNumber;
    return isEnroute;
  }
  /**
   *Check the enroute event we get against any specific stop 
  */
  checkEnrouteEvent(stopNumber: number): boolean {
    const enrouteEvents = this.shipmentEvents.events.filter((event: any) => event.stopNumber === stopNumber);
    // this.latestEnrouteEvent = enrouteEvents.find((event: any) => event.taStatusCode === 110);
    this.latestEnrouteEvent = enrouteEvents.find((event: any) => event.taStatusDescription.toLowerCase().includes('en route'));
    return this.latestEnrouteEvent;
  }
  // ---------------------------------------------- Accessors -----------------------------------------

  /**
  * Formate Date 
  */
  get formattedTimeStamp(): string | undefined {
    return this.shipmentEvents?.timeStamp ? new Date(this.shipmentEvents.timeStamp).toLocaleString() : undefined;
  }

  /**
   * Get Shipment Current Status 
   */
  get shipmentStatus(): string | null {
    return (this.shipmentEvents.events.length ? (this.shipmentEvents?.currentStatus) : this.shipment.currentStatus) || 'NA';
  }


     getTimediff(appTime: any, arrTime: any) {
    // parse and get ms since epoch (append 'Z' so it's UTC)
    const apptMs = new Date(`${appTime}Z`).getTime();
    const arrivalMs = new Date(`${arrTime}Z`).getTime();

    // difference in minutes
    const diffMinutes = (arrivalMs-apptMs) / 60000;
    return diffMinutes;

  }


  // ----------------------------------------- Get two Gps Locations Difference -----------------------------------------------------------------
  /** Convert degrees → radians */
  private toRad(deg: number): number {
    return deg * Math.PI / 180;
  }

  /** 
   * Returns distance between two GPS points in miles 
   * using the Haversine formula.
   */
  getDistanceMiles(
    lat1: number, lon1: number,
    lat2: number, lon2: number
  ): number {
    const R = 3958.8; // earth radius in miles
    const dLat = this.toRad(lat2 - lat1);
    const dLon = this.toRad(lon2 - lon1);
    const a = Math.sin(dLat/2) * Math.sin(dLat/2)
            + Math.cos(this.toRad(lat1)) 
            * Math.cos(this.toRad(lat2)) 
            * Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  /**
   * Returns true if the distance between stop and event 
   * is ≤ 0.5 miles.
   */
  isWithinHalfMile(step: any): boolean {
    if (step.latitude == null || step.longitude == null 
     || step.eventLat  == null || step.eventLong == null) {
      return false; 
    }
    return this.getDistanceMiles(
      step.latitude, step.longitude,
      step.eventLat,   step.eventLong
    ) <= 0.5;
  }


   copyCoordinates(lat: number, lng: number) {
    if (lat && lng) {
      const coords = `${lat}, ${lng}`;
      navigator.clipboard.writeText(coords).then(() => {
        this.toastr.success('Coordinates copied to clipboard!');
      }).catch(() => {
        this.toastr.error('Failed to copy coordinates.');
      });
    } else {
      this.toastr.warning('Coordinates not available.');
    }
  }

   isShipmentCompleted(){
   return this.shipmentEvents?.events?.some((event: any) => event.taStatusCode === 190) || false;
  }
}
